<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
    okText="保存"
  >
    <a-form :form="form">
      <a-form-item style="display:none">
        <a-input v-decorator="['accessoryId']" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件类型">
        <a-input v-decorator="['accessoryType', { rules: [{ required: true, message: '请输入配件类型' }] }]" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件名称">
        <a-input v-decorator="['accessoryName', { rules: [{ required: true, message: '请输入配件名称' }] }]" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件型号">
        <a-input v-decorator="['accessoryCategory', { rules: [{ required: true, message: '请输入配件型号' }] }]" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件规格">
        <a-input v-decorator="['accessorySpecification', { rules: [{ required: true, message: '请输入配件规格' }] }]" />
      </a-form-item>

      <!--      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">-->
      <!--        <a-select-->
      <!--          @change="handleRestaurantTypeChange"-->
      <!--          v-decorator="[ 'installType', {rules: [{ required: true, message: '安装类别'}]} ]" >-->
      <!--          <a-select-option v-for="type in restaurantTypes" v-bind:value="type.code">{{type.label}}</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-item>-->

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="通用配件">
        <a-select v-decorator="['commonFlag', { rules: [{ required: true, message: '通用配件' }] }]">
          <a-select-option value="0">通用</a-select-option>
          <a-select-option value="1">不通用</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
let id = 0
import { selAccessory, saveAccessory, editaccessory } from '@/api/accessory/accessory'
import { getDictMap } from '../../../utils/dict'
import pick from 'lodash.pick'
export default {
  name: 'accessoryModal',
  props: {},
  components: {},
  data() {
    return {
      accessoryId: '',
      values: '',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  beforeCreate() {
    this.form2 = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form2.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  async created() {
    this.restaurantTypes = []
    this.restaurantTypes2 = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap2 = await getDictMap('sys_learning_ways_type')
    this.restaurantOperTypeMap.forEach((value, key, mymap) => {
      this.restaurantTypes.push({ code: key, label: value })
    }),
      this.restaurantOperTypeMap2.forEach((value, key, mymap) => {
        this.restaurantTypes2.push({ code: key, label: value })
      })
    console.log(this.restaurantTypes)
  },
  methods: {
    add() {
      this.form.resetFields()
      this.edit({ accessoryId: 0 })
    },

    edit(record) {
      console.log(record)
      if (record.accessoryId != 0) {
        this.accessoryId = record.accessoryId
        let detail = Object.assign(record)
        this.restaurantOperTypeMap.forEach((value, key) => {
          if (key == detail.installType) {
            detail.installType = value
          }
          if (record.commonFlag == 0) {
            record.commonFlag = '通用'
          } else if (record.commonFlag == 1) {
            record.commonFlag = '不通用'
          }
        })
        selAccessory({ accessoryId: record.accessoryId })
          .then(res => {
            if (res.code === 0) {
              var record = res.data
              this.mdl = Object.assign(record)
              this.visible = true
              this.$nextTick(() => {
                this.form.setFieldsValue(
                  pick(
                    this.mdl,
                    'commonFlag',
                    'accessoryId',
                    'accessoryName',
                    'accessoryType',
                    'accessoryCategory',
                    'accessorySpecification',
                    'delFlag',
                    'forbiddenStatus',
                    'createBy',
                    'createTime',
                    'updateBy',
                    'updateTime'
                  )
                )
              })
              this.$emit('ok')
              // this.visible = false
            } else {
              this.$message.success(res.msg)
            }
          })
          .catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
          .finally(() => {
            this.confirmLoading = false
          })
      } else {
        this.mdl = Object.assign(record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.mdl,
              'commonFlag',
              'accessoryId',
              'accessoryName',
              'accessoryType',
              'accessoryCategory',
              'accessorySpecification',
              'delFlag',
              'forbiddenStatus',
              'createBy',
              'createTime',
              'updateBy',
              'updateTime'
            )
          )
        })
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        this.values = values
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          if (values.accessoryId != 0) {
            editaccessory(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$emit('ok', this.values, values.accessoryId)
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            saveAccessory(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  let accessoryId = res.data
                  this.$emit('ok', this.values, accessoryId, 1)
                  this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    }
  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
